<script lang="ts" setup>
  import { StoreLayout, AccountLayout } from '@storefront/components';
  import type { Paginator } from '@othercommerce/domain';
  import type { ListOrderItemResource, OrderResource } from '@storefront/resources';

  interface Props {
    products: Paginator<ListOrderItemResource>;
    order?: OrderResource;
    refund: string;
    back?: string;
  }

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  defineProps<Props>();

</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.show')">
    {{ $t('SHOP.ACCOUNT.HEADER.REFUND_CHOOSE_PRODUCTS') }}
  </AccountMobileNavigation>
  <RefundProductsView v-bind="$props" />

  <RouterView />
</template>

<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .line {
    &__heading {
      font-weight: var(--font-weight-bold);
      font-size: 1rem;
    }

    &__discount {
      font-weight: var(--font-weight-bold);
      font-size: 0.875rem;
    }

    &__property {
      font-size: 0.75rem;
      color: var(--secondary-color);
    }

    &__regular {
      color: var(--danger-color);
      font-size: 0.875rem;
      text-decoration: line-through;
    }

    &__price {
      white-space: nowrap;
    }

    :deep(.list-card__image) {
      flex: 0 0 70px;

      @include media.query(md) {
        flex: 0 0 45px;
      }

      picture, img {
        display: flex;
        aspect-ratio: 1/1;
      }
    }
  }

  .account-products {
    &__buttons {
      display: flex;
      justify-content: flex-end;
    }

    &__content {
      display: flex;
      flex-direction: column;
      row-gap: 1.25rem;
    }
  }

  @include media.query(lg) {
    .account-products {
      row-gap: 1rem;
    }
  }
</style>
